import React from "react"
import { useTranslation } from "react-i18next"
import { Grid, Typography, styled } from "@mui/material"

import { ManagerType } from "types"
import { colors } from "theme"

type Props = {
  manager?: ManagerType
  dense?: boolean
}

const ManagerComponent = ({ manager, dense = false }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      {manager && (
        <Container
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Item
            sx={{
              padding: dense ? "7px 0" : "14px 0",
            }}
          >
            <Typography component="span" variant="body1">
              {t("features.debt.manager.title")}
            </Typography>
            <Typography component="span" variant="body2" align="right">
              {manager.full_name}
            </Typography>
          </Item>
          <Item
            sx={{
              padding: dense ? "7px 0" : "14px 0",
            }}
          >
            <span />
            <Typography component="span" variant="body2" align="right">
              {manager.phone}
              <br />
              {manager.email}
            </Typography>
          </Item>
        </Container>
      )}
    </>
  )
}

ManagerComponent.defaultProps = {
  dense: false,
}

export default ManagerComponent

const Container = styled(Grid)(() => ({
  padding: "0",
  margin: "0",
}))

const Item = styled(Grid)(() => ({
  borderBottom: `1px solid ${colors.cultured}`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "14px 0",
  width: "100%",
}))
